import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth/withWidth';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ProductPart from '../ProductPart';
import Carousel from '../../../../../Framework/Components/Carousel';
import { TicBigIcon } from '../../../../../Icons';
import MobileMenuStep from '../../../../Shared/Components/MobileMenuStep';

const useStyles = makeStyles(
  (theme) => ({
    rootSm: {
      zIndex: 13,
      position: 'fixed',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0,
      background: 'white',
    },
    root: {
      zIndex: 1,
      minHeight: theme.layout.productsList.height,
      maxHeight: theme.layout.productsList.height,
      [theme.breakpoints.up('xl')]: {
        // width: `calc(100% - ${theme.spacing(4 * theme.spacingMultiplicator.xl)}px)`,
        minHeight: theme.layout.productsList.heightXL,
        maxHeight: theme.layout.productsList.heightXL,
      },
      '&.horizontal': {
        // position: 'absolute',
        height: '100%',
        '&.carousel-wrapper': {
          display: 'flex',
          alignItems: 'end',
          padding: 0,
          borderBottom: '1px solid #EFEFEF',
        },
        '& .carousel': {
          margin: 0,
          minHeight: theme.layout.productsList.height,
          maxHeight: theme.layout.productsList.height,
          [theme.breakpoints.up('xl')]: {
            // width: `calc(100% - ${theme.spacing(4 * theme.spacingMultiplicator.xl)}px)`,
            minHeight: theme.layout.productsList.heightXL,
            maxHeight: theme.layout.productsList.heightXL,
          },
          // paddingBottom: theme.spacing(0.5),
          '& .carousel-slider': {
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',

            '& > div:last-child > div > .horizontal': {

              // background: 'green !important',
              // width: 136,
            },
            '& > div > div': {
              minHeight: theme.layout.productsList.height,
              maxHeight: theme.layout.productsList.height,
              display: 'flex',
              justifyContent: 'end',

              [theme.breakpoints.up('xl')]: {
                // width: `calc(100% - ${theme.spacing(4 * theme.spacingMultiplicator.xl)}px)`,
                minHeight: theme.layout.productsList.heightXL,
                maxHeight: theme.layout.productsList.heightXL,
              },
            },
          },
        },
        // the available width (see container) is reduced by the width of the two arrows
        //  width: `calc(100% - ${theme.spacing(4)}px)`,
        [theme.breakpoints.up('sm')]: {
        },
        [theme.breakpoints.up('xl')]: {
        },
      },
    },
    overviewList: {
      padding: 0,
      margin: theme.spacing(3),
      '& .MuiListItem-root': {
        '&.active': {
          background: theme.layout.list.backgroundColorSelected,
        },
        background: theme.layout.list.backgroundColor,
        height: theme.layout.appbar.heightSm,
        padding: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.backgroundColor}`,
      },
    },
  }),
  { name: 'ProductPartsList' },
);

const ProductPartsList = ({
  displaySwitchedOptions,
  onSelect,
  optionclassifications,
  selectedoptionclassification,
  vertical,
  ProductPartComponent,
  refToStateFunc,
  width,
  currentModalContentOption,
  setModalContentOption,
  modalContentOptions,
  doDisplayMobile,
  showMarker,
  optionHasChanged,
  showApply,
}) => {
  const classes = useStyles();
  const mappedRefs = useRef({});

  const collectRefs = (ref, option) => {
    if (!mappedRefs.current[option.identifier]) {
      mappedRefs.current[option.identifier] = ref;
      if (refToStateFunc)refToStateFunc(option.identifier, ref);
    }
  };
  const renderMobileStep = () => (
    <List
      classes={
           { root: classes.overviewList }
            }
      disablePadding
    >
      {optionclassifications.map((option) => (
        <ListItem
          className={optionHasChanged[option.identifier] ? 'active' : ''}
          key={option.identifier}
          disableGutters
          button
          onClick={() => {
            setModalContentOption(modalContentOptions.RENDER_ITEMMENU);
            onSelect(option, null);
          }}
        >
          <ListItemText primary={option.title} />
          {optionHasChanged[option.identifier] && (
          <>
            <TicBigIcon />
          </>
          )}
        </ListItem>
      ))}
    </List>
  );
  return (
    <>
      {!isWidthUp('sm', width)
        ? (
          <>
            <MobileMenuStep
              doDisplay={doDisplayMobile && currentModalContentOption === modalContentOptions.RENDER_OVERVIEW}
              renderStep={renderMobileStep}
              heading={t('configurationPicker.creatorBtn')}
              closeFunc={() => {
                if (currentModalContentOption) {
                  setModalContentOption(null);
                }
              }}
              backFunc={null}
              renderActionButtonProps={showApply ? {
                title: t('colorPalettes.apply'),
                onClick: () => {
                  if (currentModalContentOption) {
                    setModalContentOption(null);
                  }
                },
              } : null}
            />
          </>
        )
        : (
          <Carousel className={clsx(classes.root, customClassName('components'), optionclassifications.length < 1 ? 'productListNoContent' : '')} vertical={vertical}>
            {optionclassifications.map((option, index) => {
              const refProps = {
                setAnchorRef: (ref) => collectRefs(ref, option),
              };
              return (
                <ProductPartComponent
                  showMarker={showMarker}
                  key={`optionclassificationitem${option.identifier}`}
                  displaySwitchedOptions={displaySwitchedOptions}
                  onSelect={onSelect}
                  optionclassification={option}
                  selectedOption={selectedoptionclassification}
                  {...refProps}
                />
              );
            })}
          </Carousel>
        )}
    </>
  );
};

ProductPartsList.defaultProps = {
  onSelect: () => {},
  optionclassifications: [],
  selectedoptionclassification: {},
  showStartHere: false,
  vertical: true,
  ProductPartComponent: ProductPart,
};

ProductPartsList.propTypes = {
  onSelect: PropTypes.func,
  optionclassifications: PropTypes.array,
  selectedoptionclassification: PropTypes.object,
  showStartHere: PropTypes.bool,
  vertical: PropTypes.bool,
  displaySwitchedOptions: PropTypes.bool,
  ProductPartComponent: PropTypes.elementType,
  CallToActionComponent: PropTypes.elementType,
  width: PropTypes.string,
};

export default withWidth({ initialWidth: 'lg' })(ProductPartsList);
